module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAAeUlEQVQ4T62S0Q2AMAhErzZxITqJA7ibAzGRMZh+aFBboIn9fo9cDxIGXhpgccNEJAB2Zp57AzR8AJgs4RGDiEzhk9kSmh/sCd02WoJZ3Vsw4VLKKiJbrTLnvLhL0YIL16lXHBfWuf/5YLi68FLC6w4fkgfWCoeO/wSvclPLxxZKbQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = 103
// module chunks = 0